/**
 * Utilities for base64 encoding/decoding.
 *
 * Used to safely transmit HTML/XML content through GraphQL APIs without triggering
 * WAF (Web Application Firewall) filters.
 */

/**
 * Encode a string to base64, handling UTF-8 characters correctly.
 *
 * Used to bypass WAF filters for content containing HTML/XML characters.
 *
 * @param str - String to encode, or null/undefined
 * @returns Base64 encoded string, or null if input was null/undefined
 */
export const encodeBase64String = (
  str: string | null | undefined
): string | null => {
  if (str == null) return null;

  // UTF-8 → binary string that btoa accepts
  const utf8Bytes = encodeURIComponent(str).replace(
    /%([0-9A-F]{2})/g,
    (_, hex) => String.fromCharCode(parseInt(hex, 16))
  );

  return btoa(utf8Bytes);
};
